import { SLICER_KEYS } from 'types/services';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { formService } from 'store/services/flow/form';
import type { TabSection } from 'types/agendaForm';

import { addNewSection } from './reducers/addNewSection';
import { renameSection } from './reducers/renameSection';
import { removeSection } from './reducers/removeSection';
import { editFormItemTab } from './reducers/editFormItemTab';
import { removeSectionItem } from './reducers/removeSectionItem';
import { reorderSectionItem } from './reducers/reorderSectionItem';
import { resetSection } from './reducers/resetSection';
import { updateSectionItem } from './reducers/updateSectionItem';
import { setSectionGrid } from './reducers/setSectionGrid';
import { syncSections } from './reducers/syncSections';
import { overwriteAllVisibilities } from './reducers/overwriteAllVisibilities';
import { updateSectionItemVisibilities } from './reducers/updateSectionItemVisibilities';
import { reorderSections } from './reducers/reorderSections';
import { reorderFormItemTabs } from './reducers/reorderFormItemTabs';
import { reorderTabSections } from './reducers/reorderTabSections';
import { moveSectionToTab } from './reducers/moveSectionToTab';
import { resizeSectionItem } from './reducers/resizeSectionItem';
import type { GetAgendasFormRes } from 'types';

export interface ModulesAndAgendasState {
  tabSections: TabSection[];
}

const initialState: ModulesAndAgendasState = {
  tabSections: [],
};

export const modulesAndAgendasState = createSlice({
  name: SLICER_KEYS.MODULES_AND_AGENDAS,
  initialState,
  reducers: {
    addNewSection,
    renameSection,
    editFormItemTab,
    removeSection,
    removeSectionItem,
    reorderSectionItem,
    resetSection,
    updateSectionItem,
    setSectionGrid,
    overwriteAllVisibilities,
    updateSectionItemVisibilities,
    reorderSections,
    reorderFormItemTabs,
    reorderTabSections,
    moveSectionToTab,
    resizeSectionItem,
    syncSections: (state, { payload }: PayloadAction<GetAgendasFormRes>) => {
      syncSections(state, payload);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(formService.endpoints.getAgendasForms.matchFulfilled, (state, { payload }) => {
      syncSections(state, payload);
    });
  },
});

export const modulesAndAgendasActions = modulesAndAgendasState.actions;
